import {IEntity} from '../entity/core.base.entity.interface';
import {Metadata} from '../entity/core.entity.metadata';

export interface IPage<TEntity extends IEntity> {
    content: TEntity[];
    pageSize: number;
    page: number;
    total: number;
    metadata: Metadata;
}